// M7.3 — one flag per layer, each strictly `=== 'true'`.
// Unset / 'false' / '1' / 'yes' / 'TRUE' all stay OFF.
//
//   VITE_AGENT_SURFACE_CONTEXT_ENABLED — the POST /api/agent/surface-context fetch
//   VITE_AGENT_NUDGES_ENABLED          — inline nudge cards
//   VITE_AGENT_ATTENTION_MARKS_ENABLED — attention marks on surface rows
//
// The client does not choose LLM narration. The server decides, inside
// the operator's $0.50/day narration budget and the $5/day agent cap,
// and the client shows the rules text when narration is unavailable.
//
// Visuals that these flags reveal are pending Mark's design sign-off.
// See AGENT_SHELL_VISUAL_STATUS in ./types.

type ShellEnv = {
  VITE_AGENT_SURFACE_CONTEXT_ENABLED?: string;
  VITE_AGENT_NUDGES_ENABLED?: string;
  VITE_AGENT_ATTENTION_MARKS_ENABLED?: string;
};

function envOr(env?: ShellEnv): ShellEnv {
  return env ?? (import.meta.env as ShellEnv);
}

export function surfaceContextEnabled(env?: ShellEnv): boolean {
  return envOr(env).VITE_AGENT_SURFACE_CONTEXT_ENABLED === 'true';
}

export function nudgesEnabled(env?: ShellEnv): boolean {
  return envOr(env).VITE_AGENT_NUDGES_ENABLED === 'true';
}

export function attentionMarksEnabled(env?: ShellEnv): boolean {
  return envOr(env).VITE_AGENT_ATTENTION_MARKS_ENABLED === 'true';
}
